var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notification_Read_svg__clip0_16517_20737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.158 4.08h.01v.01l-.01-.01z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.07 9.616h.008l-2.632-1.84L14.67 4.76h-1.528l-.968-.68-.12-.08-.12.088h-.008l-.968.68H6.574v3.056L3.99 9.608V20.32h16.104V9.648l-.024-.024v-.008zm-2.072.072l.736.52-.744.744V9.68l.008.008zM14.19 5.784v3.048h2.784v3.144l-1.512 1.512v-.608H12.27l-.096-.072-.12-.088-.128.088-.096.072H9.134v1.016h1.232l-.776.536-1.984-1.984V5.784h6.592-.008zm.312 8.656l-.776-.536h1.32l-.544.544v-.008zm-7.928-3l-1.232-1.232 1.232-.864v2.096zm5.472 2.8l1.56 1.096 1.04.728.896-.896 3.312-3.312v5.616l-3.312-2.312-.896.896L18.854 19v.064H5.238v.008V10.016v1.824l3.312 3.312.96-.664-.96.68-3.312 2.32v1.528l4.208-2.944 1.04-.728 1.568-1.096",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.462 10.848H9.118v1.016h6.344v-1.016z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Notification_Read_svg__clip0_16517_20737"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.99 4)",
    d: "M0 0h16.104v16.312H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/Notification_Read.29c2e600.svg";
export { SvgNotificationRead as ReactComponent };